import { DsButton } from '@frontends/ds';
import { useCallback } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleReset = useCallback(() => {
    resetErrorBoundary();
    navigate('/', { replace: true });
  }, [navigate, resetErrorBoundary]);

  return (
    <div role="alert" className="w-full h-[300px] flex items-center justify-center">
      <div>
        <p>{t('something_went_wrong')}:&nbsp;</p>
        <pre className="text-textDangerPrimary">{error.message}</pre>
        <DsButton size="lg" className="mt-5" onPress={handleReset}>
          {t('go_home')}
        </DsButton>
      </div>
    </div>
  );
};

export default Fallback;
